import type { RedcatAnalyticsStore } from '../types/store';
import { MarketingTrackEventName } from '../types/marketing';
import type { MarketingTrackEvent } from '../types/events/track';

export const trackMarketingEmailOptInToggled = (
  track: RedcatAnalyticsStore['track'],
  { optedIn, isDefaultState }: { optedIn: boolean; isDefaultState: boolean },
) => {
  const event: MarketingTrackEvent = {
    name: MarketingTrackEventName.EmailOptInToggled,
    properties: {
      opted_in: optedIn,
      is_default_state: isDefaultState,
    },
  };

  track(event);
};
